'use client';

import { Chip } from '@coolblue-development/freddy';
import { Clock } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import { Hours } from '@sharedTypes';
import { isHoursRange } from '@utils/type-guards/hours';

type Props = {
  hours: Hours;
};

export const HoursChip = ({ hours }: Props) => {
  const { t } = useTranslation('vacancyDetail.header.hours');

  const parsedHours = isHoursRange(hours) && hours.min === hours.max ? { value: hours.min } : hours;

  const hoursChipText = isHoursRange(parsedHours)
    ? t('range', { min: parsedHours.min, max: parsedHours.max })
    : t('fixed', { value: parsedHours.value });

  return <Chip startIcon={<Clock />}>{hoursChipText}</Chip>;
};
